module.exports = __webpack_public_path__ + "img/SprayPainting2.26a0081b.jpg";